export function ChatBubble({ role, text }) {
    const isUser = role === "user";
    return (
        <div className={`flex ${isUser ? "justify-end" : "justify-start"}`}>
            <div className={`max-w-[85%] rounded-2xl px-4 py-2.5 text-sm whitespace-pre-wrap leading-relaxed ${
                isUser ? "bg-primary text-primary-foreground" : "bg-muted"}`} data-testid={`chat-${role}`}>
                {text}
            </div>
        </div>
    );
}
